import React from 'react';

import Pill, { PillProps } from '@ingka/pill';

export default (props: PillProps) => <Pill prefix="list-ingka-" {...props} />;
